import React from 'react';


export default function LinkifyDecorator(decoratedHref, decoratedText, key) {
  return (
    <a href={decoratedHref} key={key} target='_blank'>
      {decoratedText}
    </a>
  );
};